<!-- Category Filters / Legend -->
<div class="category-filters">
  <!-- Daily Log Category Filters -->
  <div class="filter-group">
    <h3 class="filter-group-title">Daily Logs</h3>
    <div class="filters">
      @for (category of dailyCategories; track category) {
        <label class="filter">
          <input
            type="checkbox"
            [checked]="visibleCategories.has(category.key)"
            (change)="toggleCategory(category.key, $event)"
            />
          <span
            class="custom-checkbox"
            [style.background-color]="category.color"
          ></span>
          <span class="category-label">{{ category.label }}</span>
        </label>
      }
    </div>
  </div>

  <!-- General Log Category Filters -->
  <div class="filter-group">
    <h3 class="filter-group-title">General Emissions (Averaged Per Day)</h3>
    <div class="filters">
      @for (category of baselineCategories; track category) {
        <label class="filter">
          <input
            type="checkbox"
            [checked]="visibleCategories.has(category.key)"
            (change)="toggleCategory(category.key, $event)"
            />
          <span
            class="custom-checkbox"
            [style.background-color]="category.color"
          ></span>
          <span class="category-label">{{ category.label }}</span>
        </label>
      }
    </div>
  </div>
</div>

<!-- Date Range Picker -->
@if (isReportDataAvailable) {
  <app-date-range-picker
    (datesGenerated)="onDatesGenerated($event)"
  ></app-date-range-picker>
}

<!-- Charts Container -->
<div class="charts-container">
  <!-- Main Emissions Chart -->
  <app-card title="My CO₂ Emissions Overview" class="chart-card">
    @if (isReportDataAvailable && displayedDates.length > 0) {
      <div class="chart-wrapper">
        <div class="emissions-chart" style="touch-action: pan-x"></div>
        <div class="scroll-hint">
          <app-icon name="arrow_left" color="grey"></app-icon>
          <small>Scroll horizontally if needed</small>
          <app-icon name="arrow_right" color="grey"></app-icon>
        </div>
      </div>
      <div class="chart-controls">
        <!-- Download Button -->
        <button class="btn" (click)="downloadReport()">
          <app-icon name="download" color="white"></app-icon>
          Download weekly report (.csv)
        </button>
      </div>
    }
    @if (!isReportDataAvailable) {
      <p>
        Please add some daily logs and general emissions to see your personal
        emissions chart.
      </p>
    }
  </app-card>

  <!-- Comparison Chart -->
  <app-card title="Compare with others" class="chart-card">
    <div class="chart-wrapper">
      <div class="comparison-chart" style="touch-action: pan-x"></div>
      <div class="scroll-hint">
        <app-icon name="arrow_left" color="grey"></app-icon>
        <small>Scroll horizontally if needed</small>
        <app-icon name="arrow_right" color="grey"></app-icon>
      </div>
    </div>
  </app-card>
</div>

<!-- Shared tooltip -->
<div class="tooltip"></div>